import { get } from '@/backend/api'
import type { ParsedError } from '@/backend/error'
import { isErrorResponse, parseError } from '@/backend/error'

import type { operations } from './api'

type Operation = operations['billing-plans-designated-plans']
export type DesignatedPlans = Operation['responses']['200']['content']['application/json']

export const getDesignatedPlans = async (
  teamSlug: string,
): Promise<{ data: DesignatedPlans } | ParsedError> => {
  try {
    const result = await get<DesignatedPlans>(`/teams/${teamSlug}/billing/designated_plans`)
    return { data: result.data }
  } catch (error: unknown) {
    if (!isErrorResponse(error)) {
      throw error
    }

    return parseError(error)
  }
}
